import React from "react";
import { ReactComponent as UserIcon } from "../../images/user.svg";
import {
  Card,
  CardBody,
  CardHeader,
  Row,
  Col,
  Container,
  CardFooter,
  ModalFooter,
} from "reactstrap";

function HouseHoldModal(props: any) {
  return (
    <>
      <Container className="rolodex-headers">
        <Row className="header-bottom">
          <Col md={8} className="d-flex user-thumb-wrap">
            <div className="user-thumb">
              <UserIcon />
            </div>
            <div className="lead-name-wrap">
              <h6 className="lead-name">{props?.data?.contactName}</h6>
              <h6 className="lead-name">{props?.data?.title}</h6>
              <span className="lead-title"></span>
            </div>
          </Col>
          <Col md={4}></Col>
        </Row>
      </Container>

      <CardBody className="bottom-text">
        <Container>
          <Row>
            <Col>
              <Row className="label">
                Email <span className="badge badge-light"></span>
              </Row>
              <Row className="label-text">{props?.data?.email}</Row>
            </Col>
          </Row>
          <Row>
            <Col md="8">
              <Row className="label">Cell Phone</Row>
              <Row className="label-text">{props?.data?.phoneNumber}</Row>
            </Col>
          </Row>
          <Row>
            <Col md="8">
              <Row className="label">Address</Row>
              <Row className="label-text">{props?.data?.streetAddress}</Row>
              <Row className="label-text">
                {props?.data?.state} {props?.data?.zipCode}{" "}
                {props?.data?.unitSuite}
              </Row>
            </Col>

            <Col md="4">
              <Row className="label">DOB</Row>
              <Row className="label-text">{props?.data?.dob}</Row>
            </Col>
          </Row>
        </Container>
      </CardBody>
      <CardFooter className="card-footer"></CardFooter>
    </>
  );
}

export default HouseHoldModal;
